<template  >


    <v-container style="margin-top:60px;" >
        <v-card class="mx-auto" dark style="background:transparent;" flat>
            <div style="text-align: center;">Event Log</div>
        <v-card-text style="text-align: center;">
            Här visas dina senaste events. Så som donationer, Hicards-flex och Hicards-användning.
        </v-card-text>

                <v-row align="center" justify="center" style="width:100%;" >
                    <v-col align="center" justify="center" cols="12" style="display:flex;">
                        <v-spacer></v-spacer>
                        <v-checkbox
                                v-model="show_unverified_events"
                                label="Inkludera overifierade donationer*"
                        ></v-checkbox>
                        <v-spacer></v-spacer>
                    </v-col>
                    <v-col  align="center" justify="center" cols="12" style="display:flex;margin-top:-50px;">
                        <v-card-text style="text-align: center;color:gray;font-size:12px;">
                            *donationer Hihat är osäkra på om de kommit fram
                        </v-card-text>

                    </v-col>
                </v-row>




        </v-card>

        <v-row style="max-width: 800px;" class="mx-auto" justify="center" align="center" >
            <v-col cols="12" v-for="(event,index) in events" :key="index">
                <v-card
                        dark
                        class="mx-auto"
                        style="padding: 20px;"
                        :class="event.TYPE==='donation_unverified'? 'unverified':''"
                >


                    <v-card-text style="padding-top:0;padding-bottom: 0;margin-top:-10px;">
                        <div v-if="event.TYPE==='donation_unverified'" class="overline" style="margin-bottom: -20px;display:flex;white-space: nowrap;">
                            <v-spacer></v-spacer>
                            <v-icon small>warning</v-icon>overifierad
                            <v-spacer></v-spacer>
                        </div>
                        <v-row align="center" style="max-height: 100px;">
                            <v-col cols="6" align="center" style="padding: 0;">
                                <v-list-item v-if="event.TYPE==='donation' || event.TYPE==='donation_verified'" three-line style="padding: 0;" >
                                    <v-list-item-content>
                                        <v-list-item-title style="text-align: left;" > {{event.DATA.SENDER_NAME}}</v-list-item-title>
                                        <v-list-item-subtitle style="text-align: left;">Donerade {{event.DATA.AMOUNT}} kr {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                        <v-list-item-subtitle style="text-align: left;">"<i>{{event.DATA.MESSAGE}}</i> "</v-list-item-subtitle>

                                    </v-list-item-content>
                                </v-list-item>
                              <v-list-item v-if="event.TYPE==='video'" three-line style="padding: 0;" >
                                <v-list-item-content>
                                  <v-list-item-title style="text-align: left;" > {{event.DATA.sender}}</v-list-item-title>
                                  <v-list-item-subtitle style="text-align: left;">Donerade {{event.DATA.amount}} kr med video-alert {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                  <v-list-item-subtitle style="text-align: left;"><a target="_blank" :href="'https://www.youtube.com/watch?v='+event.DATA.id">youtube.com/watch?v={{event.DATA.id}}</a> </v-list-item-subtitle>

                                </v-list-item-content>
                              </v-list-item>
                                <v-list-item v-if="event.TYPE==='donation_unverified'" three-line style="padding: 0;" >
                                    <v-list-item-content>
                                        <v-list-item-title style="text-align: left;white-space: nowrap;display:flex;" > {{event.DATA.SENDER_NAME}}</v-list-item-title>
                                        <v-list-item-subtitle style="text-align: left;">Donerade {{event.DATA.AMOUNT}} kr {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                        <v-list-item-subtitle style="text-align: left;">"<i>{{event.DATA.MESSAGE}}</i> "</v-list-item-subtitle>

                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="event.TYPE==='action'" three-line style="padding: 0;" >
                                    <v-list-item-content>
                                        <v-list-item-title style="text-align: left;" > {{event.DATA.USER_NAME}}</v-list-item-title>
                                        <v-list-item-subtitle style="text-align: left;">Använde <b><span style="font-weight:800;" :style="{'color':colors[event.DATA.RANK]}">{{event.DATA.NAME}}</span></b> {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                        <v-list-item-subtitle style="text-align: left;">"<i>{{event.DATA.TEXT}}</i> "</v-list-item-subtitle>

                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="event.TYPE==='collection'" three-line style="padding: 0;" >
                                    <v-list-item-content>
                                        <v-list-item-title style="text-align: left;" > {{event.DATA.USER_NAME}}</v-list-item-title>
                                        <v-list-item-subtitle style="text-align: left;">Flexade <b><span style="font-weight:800;" :style="{'color':colors[event.DATA.RANK_VALUE]}">{{event.DATA.NAME}}</span></b> {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                        <v-list-item-subtitle style="text-align: left;">Float: {{(Math.sqrt((event.DATA.FLOAT_X*event.DATA.FLOAT_X)+(event.DATA.FLOAT_Y*event.DATA.FLOAT_Y))/Math.sqrt(2)).toFixed(2)}} </v-list-item-subtitle>

                                    </v-list-item-content>
                                </v-list-item>
                              <v-list-item v-if="event.TYPE==='collection'" three-line style="padding: 0;" >
                                <v-list-item-content>
                                  <v-list-item-title style="text-align: left;" > {{event.DATA.USER_NAME}}</v-list-item-title>
                                  <v-list-item-subtitle style="text-align: left;">Flexade <b><span style="font-weight:800;" :style="{'color':colors[event.DATA.RANK_VALUE]}">{{event.DATA.NAME}}</span></b> {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                  <v-list-item-subtitle style="text-align: left;">Float: {{(Math.sqrt((event.DATA.FLOAT_X*event.DATA.FLOAT_X)+(event.DATA.FLOAT_Y*event.DATA.FLOAT_Y))/Math.sqrt(2)).toFixed(2)}} </v-list-item-subtitle>

                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item v-if="event.TYPE==='product'" three-line style="padding: 0;" >
                                <v-list-item-content>
                                  <v-list-item-title style="text-align: left;" > {{event.DATA.SENDER_NAME}}</v-list-item-title>
                                  <v-list-item-subtitle style="text-align: left;">Köpte <b>"{{event.DATA.NAME}}"</b> för {{event.DATA.PRICE}} kr {{get_string_from(event.MINUTES_PASSED)}}</v-list-item-subtitle>
                                  <v-list-item-subtitle style="text-align: left;"><i>{{event.DATA.COMMAND}}</i></v-list-item-subtitle>

                                </v-list-item-content>
                              </v-list-item>
                            </v-col>

                            <v-col cols="6" align="right" style="padding: 0;">
                                <v-btn v-if="event.TYPE==='donation_unverified'" icon @click="verify(event.EID)" > <v-icon>mdi-check</v-icon> </v-btn>
                                <v-btn v-else-if="event.TYPE==='product'" icon @click="replay_product(event.REF)" > <v-icon>mdi-replay</v-icon> </v-btn>
                              <v-btn v-else-if="event.TYPE==='video'" icon @click="replay_video(event.DATA)" > <v-icon>mdi-replay</v-icon> </v-btn>

                              <v-btn v-else icon @click="replay(event.EID)"> <v-icon>mdi-replay</v-icon> </v-btn>

                            </v-col>

                        </v-row>
                    </v-card-text>


                </v-card>
            </v-col>


        </v-row>


    </v-container>

</template>

<script>

    export default {
        name: "Logg",
        components:{},
        data:function(){
            return{
                events:[],
                unfiltered_events:[],
                colors:["green","blue","purple","orange"],
                show_unverified_events:true


            }
        },
        methods:{

          replay_video:function(video_info){
            let http = new XMLHttpRequest();

            http.withCredentials = true;
            let url = '/api/replay_video?';
            let self=this;
            let params="video_info="+JSON.stringify(video_info)
            http.open('POST', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            http.onreadystatechange = function() {

              if(http.readyState === 4 && http.status === 403) {
                self.$store.commit("update_snackbar","Ett fel inträffade, försök igen senare");
              }
              else if(http.readyState === 4 && http.status === 200){
                self.$store.commit("update_snackbar","Kommandot återspelas");
              }

            };
            http.send(params);
          },

            replay_product:function(id){
              let http = new XMLHttpRequest();

              http.withCredentials = true;
              let url = '/api/replay_product?';
              let self=this;
              let params="id="+id;
              http.open('POST', url, true);
              http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
              http.onreadystatechange = function() {

                if(http.readyState === 4 && http.status === 403) {
                  self.$store.commit("update_snackbar","Ett fel inträffade, försök igen senare");
                }
                else if(http.readyState === 4 && http.status === 200){
                  self.$store.commit("update_snackbar","Kommandot återspelas");
                }

              };
              http.send(params);
            },

            replay:function(id){
                let http = new XMLHttpRequest();

                http.withCredentials = true;
                let url = '/api/replay_event?';
                let self=this;
                let params="id="+id;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {
                        self.$store.commit("update_snackbar","Ett fel inträffade, försök igen senare");
                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Eventet återspelas");
                    }

                };
                http.send(params);
            },
            verify:function(id){
                let http = new XMLHttpRequest();

                http.withCredentials = true;
                let url = '/api/verify_event?';
                let self=this;
                let params="id="+id;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {
                        self.$store.commit("update_snackbar","Ett fel inträffade, försök igen senare");
                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Donationen verifierades");
                        self.getEvents();
                    }

                };
                http.send(params);
            },
            get_string_from:function(min) {

                let returnstring = "";
                if (min <= 2) {
                    returnstring = "precis nu."
                } else if (min < 60) {
                    returnstring = `för ${parseInt(min)} minuter sedan.`
                } else if (min < 120) {
                    returnstring = `för 1 timme sedan.`
                } else if (min < 1440) {
                    returnstring = `för ${parseInt(min / 60)} timmar sedan.`
                } else if (min < 2880) {
                    returnstring = `för 1 dag sedan.`
                } else {
                    returnstring = `för ${parseInt(min / (60 * 24))} dagar sedan.`
                }

                return returnstring;
            },


            getEvents:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/get_events';
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200){
                        let resp=JSON.parse(http.response);
                        if(resp.length>20){
                            resp=resp.splice(0,20);
                        }
                        for(let i=0;i<resp.length;i++){
                            resp[i].DATA=JSON.parse(resp[i].DATA)
                        }
                        self.events=resp;
                        self.unfiltered_events=resp;
                    }};
                http.send();
            },

        },
        computed:{
        },
        watch:{
            show_unverified_events:function(show_unverified){
                if(!show_unverified){
                    this.events=this.events.filter(filter_unverified);
                }
                else{
                    this.events=this.unfiltered_events;
                }
            }
        },
        mounted:function(){
            this.getEvents();
        }
    }

    function filter_unverified(event) {
        return event.TYPE!=="donation_unverified";
    }


</script>

<style >

    .unverified{

        border: 2px solid #ffaa0075 !important;
    }

</style>
